// Generouted, changes to this file will be overriden
/* eslint-disable */

import { hooks, utils } from "@generouted/react-router/client";
import { components } from "@web-monorepo/routing";

export type Path =
  | `/`
  | `/additional-single-class/match`
  | `/additional-single-class/step-five`
  | `/additional-single-class/step-four`
  | `/additional-single-class/step-one`
  | `/additional-single-class/step-six`
  | `/additional-single-class/step-three`
  | `/additional-single-class/step-two`
  | `/ai-transparency-note`
  | `/apply/status`
  | `/book-more-classes`
  | `/book-more-classes/with-tutor/:tutorId`
  | `/checkout`
  | `/checkout/group-success`
  | `/checkout/success`
  | `/child-privacy-terms`
  | `/communityguidelines`
  | `/confirm-details`
  | `/contentpolicy`
  | `/cookies-policy`
  | `/course/:courseId`
  | `/diagnostic`
  | `/diagnostic/DiagnosticProvider`
  | `/diagnostic/interstitial-1`
  | `/diagnostic/interstitial-2`
  | `/diagnostic/question-1`
  | `/diagnostic/question-10`
  | `/diagnostic/question-2`
  | `/diagnostic/question-3`
  | `/diagnostic/question-4`
  | `/diagnostic/question-5`
  | `/diagnostic/question-6`
  | `/diagnostic/question-7`
  | `/diagnostic/question-8`
  | `/diagnostic/question-9`
  | `/diagnostic/results`
  | `/diagnostic/transition`
  | `/diagnostic/welcome`
  | `/direct-booking-subscription/child-information`
  | `/direct-booking-subscription/parent-signup`
  | `/direct-booking-subscription/subject-selection`
  | `/direct-booking-subscription/tutor-introduction/:tutorId`
  | `/direct-booking-subscription/tutor-introduction/tutor/:tutorId`
  | `/faq`
  | `/flier`
  | `/for-teachers`
  | `/forgot-password`
  | `/forgot-password/reset/:token`
  | `/groupclass/search`
  | `/how-dojo-tutor-works`
  | `/login`
  | `/login/67feee1cbf7d47626977952f`
  | `/login/685166089bcc65f32d3f8c46`
  | `/login/code`
  | `/login/code/:email`
  | `/parents/account-settings`
  | `/parents/chats`
  | `/parents/chats/:messageThreadId`
  | `/parents/classes`
  | `/parents/classes/assessment/:classId`
  | `/parents/classes/assessment/student-session/:studentSessionId`
  | `/parents/classesMobile`
  | `/parents/clips/:sessionId`
  | `/parents/coppa`
  | `/parents/coppa/:slug`
  | `/parents/favorites`
  | `/parents/home`
  | `/parents/pastClasses`
  | `/parents/pastClasses/:sessionId`
  | `/parents/payment-history`
  | `/parents/reschedule/:classId`
  | `/parents/reschedule/subscription/class/:classId`
  | `/parents/reschedule/subscription/session/:sessionId`
  | `/parents/reschedule/subscription/student-session/:studentSessionId`
  | `/parents/reschedule/trial/session/:sessionId`
  | `/parents/session/:sessionId/manage`
  | `/parents/session/:sessionId/manage/all-times`
  | `/parents/share-assessment/:stripeSubscription`
  | `/partners/:partnerCode`
  | `/privacy`
  | `/recap/:tutorAnnualRecapId`
  | `/referrals`
  | `/referrals/:referralCode`
  | `/referrals/inviter`
  | `/resume-funnel/:key`
  | `/safeguarding`
  | `/search`
  | `/searchlp1`
  | `/searchlp2`
  | `/searchlp3`
  | `/searchlp3/results`
  | `/single-class`
  | `/single-class/:stepName`
  | `/story`
  | `/student-session/:studentSessionId`
  | `/subscription/booking/class/:classId/redirect-from-class`
  | `/subscription/booking/outcome-priority`
  | `/subscription/booking/outcome-progress`
  | `/subscription/booking/select-class-frequency`
  | `/subscription/booking/select-times`
  | `/subscription/booking/student-session/:studentSessionId/redirect`
  | `/subscription/booking/timeline-priority`
  | `/subscription/booking/timeline-progress`
  | `/subscription/manage`
  | `/subscription/manage/:subscriptionId/cancel/complete`
  | `/subscription/manage/:subscriptionId/cancel/confirmation`
  | `/subscription/manage/:subscriptionId/cancel/modify-schedule`
  | `/subscription/manage/:subscriptionId/cancel/reason`
  | `/subscription/manage/:subscriptionId/cancel/try-new-tutor-free`
  | `/subscription/manage/:subscriptionId/cancel/verify-stop-tutoring`
  | `/subscription/manage/:subscriptionId/confirm-schedule`
  | `/subscription/manage/:subscriptionId/pause`
  | `/subscription/manage/:subscriptionId/pause/complete/:pausedUntil`
  | `/subscription/reschedule/:subscriptionId`
  | `/subscription/schedule-update/:subscriptionId`
  | `/summer-boost`
  | `/teachEmbed`
  | `/teacher`
  | `/teachers`
  | `/teachers/*`
  | `/termsofservice`
  | `/third-party-service-providers`
  | `/transparency`
  | `/tutor`
  | `/tutor/account-settings`
  | `/tutor/apply`
  | `/tutor/automated-messages`
  | `/tutor/availability`
  | `/tutor/calendar`
  | `/tutor/calendar/:sessionId`
  | `/tutor/calendar/assessment/:assessmentId`
  | `/tutor/calendar/assessment/session/:sessionId`
  | `/tutor/calendar/date/:date`
  | `/tutor/calendar/day`
  | `/tutor/calendar/day/:date`
  | `/tutor/calendar/week`
  | `/tutor/calendar/week/:date`
  | `/tutor/chats`
  | `/tutor/chats/:messageThreadId`
  | `/tutor/community`
  | `/tutor/course/:courseId/edit`
  | `/tutor/course/:courseId/manage`
  | `/tutor/course/:courseId/section/create`
  | `/tutor/course/:courseId/submitted`
  | `/tutor/course/create`
  | `/tutor/course/manage`
  | `/tutor/generated-assessment/:generatedAssessmentId/review`
  | `/tutor/insights`
  | `/tutor/payouts`
  | `/tutor/payouts/detail`
  | `/tutor/price-settings`
  | `/tutor/profile`
  | `/tutor/profile/:tutorId`
  | `/tutor/section/:sectionId`
  | `/tutor/session/:sessionId`
  | `/tutor/session/:sessionId/lessonPlan`
  | `/tutor/settings`
  | `/tutor/settings/account`
  | `/tutor/settings/availability`
  | `/tutor/settings/calendar`
  | `/tutor/settings/notifications`
  | `/tutor/settings/preferences`
  | `/tutor/subscriptions`
  | `/tutor/subscriptions/:subscriptionId`
  | `/tutor/tutor-set-pricing-onboarding`
  | `/winter-math-boost`
  | `/winter-reading-boost`;

export type Params = {
  "/book-more-classes/with-tutor/:tutorId": { tutorId: string };
  "/course/:courseId": { courseId: string };
  "/direct-booking-subscription/tutor-introduction/:tutorId": { tutorId: string };
  "/direct-booking-subscription/tutor-introduction/tutor/:tutorId": { tutorId: string };
  "/forgot-password/reset/:token": { token: string };
  "/login/code/:email": { email: string };
  "/parents/chats/:messageThreadId": { messageThreadId: string };
  "/parents/classes/assessment/:classId": { classId: string };
  "/parents/classes/assessment/student-session/:studentSessionId": { studentSessionId: string };
  "/parents/clips/:sessionId": { sessionId: string };
  "/parents/coppa/:slug": { slug: string };
  "/parents/pastClasses/:sessionId": { sessionId: string };
  "/parents/reschedule/:classId": { classId: string };
  "/parents/reschedule/subscription/class/:classId": { classId: string };
  "/parents/reschedule/subscription/session/:sessionId": { sessionId: string };
  "/parents/reschedule/subscription/student-session/:studentSessionId": { studentSessionId: string };
  "/parents/reschedule/trial/session/:sessionId": { sessionId: string };
  "/parents/session/:sessionId/manage": { sessionId: string };
  "/parents/session/:sessionId/manage/all-times": { sessionId: string };
  "/parents/share-assessment/:stripeSubscription": { stripeSubscription: string };
  "/partners/:partnerCode": { partnerCode: string };
  "/recap/:tutorAnnualRecapId": { tutorAnnualRecapId: string };
  "/referrals/:referralCode": { referralCode: string };
  "/resume-funnel/:key": { key: string };
  "/single-class/:stepName": { stepName: string };
  "/student-session/:studentSessionId": { studentSessionId: string };
  "/subscription/booking/class/:classId/redirect-from-class": { classId: string };
  "/subscription/booking/student-session/:studentSessionId/redirect": { studentSessionId: string };
  "/subscription/manage/:subscriptionId/cancel/complete": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/cancel/confirmation": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/cancel/modify-schedule": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/cancel/reason": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/cancel/try-new-tutor-free": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/cancel/verify-stop-tutoring": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/confirm-schedule": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/pause": { subscriptionId: string };
  "/subscription/manage/:subscriptionId/pause/complete/:pausedUntil": { subscriptionId: string; pausedUntil: string };
  "/subscription/reschedule/:subscriptionId": { subscriptionId: string };
  "/subscription/schedule-update/:subscriptionId": { subscriptionId: string };
  "/teachers/*": { "*": string };
  "/tutor/calendar/:sessionId": { sessionId: string };
  "/tutor/calendar/assessment/:assessmentId": { assessmentId: string };
  "/tutor/calendar/assessment/session/:sessionId": { sessionId: string };
  "/tutor/calendar/date/:date": { date: string };
  "/tutor/calendar/day/:date": { date: string };
  "/tutor/calendar/week/:date": { date: string };
  "/tutor/chats/:messageThreadId": { messageThreadId: string };
  "/tutor/course/:courseId/edit": { courseId: string };
  "/tutor/course/:courseId/manage": { courseId: string };
  "/tutor/course/:courseId/section/create": { courseId: string };
  "/tutor/course/:courseId/submitted": { courseId: string };
  "/tutor/generated-assessment/:generatedAssessmentId/review": { generatedAssessmentId: string };
  "/tutor/profile/:tutorId": { tutorId: string };
  "/tutor/section/:sectionId": { sectionId: string };
  "/tutor/session/:sessionId": { sessionId: string };
  "/tutor/session/:sessionId/lessonPlan": { sessionId: string };
  "/tutor/subscriptions/:subscriptionId": { subscriptionId: string };
};

export type ModalPath = never;

export const { Link, Navigate } = components<Path, Params>();
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>();
export const { redirect } = utils<Path, Params>();
